import { createFileRoute, Link } from '@tanstack/react-router'
import { useTranslations } from 'gt-react'
import { Shield } from 'lucide-react'
import { PageHeader } from '@/components/layout/page-header'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

export const Route = createFileRoute('/settings/custom-modules/$key/permissions')({
  component: ModulePermissionsPage,
})

function ModulePermissionsPage() {
  const { key } = Route.useParams()
  const t = useTranslations()
  return (
    <>
      <PageHeader
        title={t('builderRuntime.permissions.title')}
        subtitle={t('builderRuntime.permissions.subtitle')}
      />
      <Card>
        <CardContent className="py-8 text-center">
          <Shield className="h-12 w-12 text-muted-foreground mx-auto mb-3" />
          <p className="text-sm text-muted-foreground mb-4 max-w-md mx-auto">
            {t('builderRuntime.permissions.body')}
          </p>
          <Button asChild>
            <Link to="/settings/roles" search={{ module: key } as never}>
              {t('builderRuntime.permissions.openRoles')}
            </Link>
          </Button>
        </CardContent>
      </Card>
    </>
  )
}
